<div>
  <ng-template
    [carsFragmentHost]="sectionChildren"
    [readOnly]="true"
    [currentView]="currentView"
    [padType]="PadType.NO_PAD"
  ></ng-template>
</div>
